<div class="modal-header">
  <h4 class="modal-title">Rename Company</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="flex flex-row pb-3">
    <div>
      <div class="flex flex-row space-x-4">
        <div class="dx-field flex">
          <div class="pt-2 pr-2.5 pb-2 pl-0">Company:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="selectedEditCompanyOldName" [readOnly]="true"></dx-text-box>
          </div>
        </div>
        <div class="dx-field flex">
          <div class="pt-2 pr-1 pb-2 pl-0">Id:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="companyId" [readOnly]="true"></dx-text-box>
          </div>
        </div>
      </div>
      <div class="flex flex-row space-x-4">
        <div class="dx-field flex">
          <div class="pt-2 pr-1 pb-2 pl-0">Change To:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="selectedEditCompanyNewName" valueChangeEvent="keyup" (onValueChanged)="valueChanged($event)">
              <dx-validator>
                <dxi-validation-rule 
                    type="required" 
                    message="Field is required">
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col">
    <h4>Affected Company with Current OLD Name</h4>
    <div class="pb-3">
      <dx-data-grid
        [dataSource]="afftectedCompanyNameData" 
        [showBorders]="true" 
        [columnAutoWidth]="true" 
      >
        <dxi-column dataField="Id" caption="Company Id" [customizeText]="customizeCompanyId"></dxi-column>
        <dxi-column dataField="Name" caption="Company"></dxi-column>
      </dx-data-grid>
    </div>
    <h4>Existing Company with intended NEW Name</h4>
    <div>
      <dx-data-grid
        #existingCompanyNameGrid
        id="existingCompanyNameGrid"
        [dataSource]="existingCompanyNameData" 
        [showBorders]="true" 
        [columnAutoWidth]="true" 
      >
        <dxi-column dataField="Id" caption="Company Id"></dxi-column>
        <dxi-column dataField="Name" caption="Company"></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <dx-button
    icon="check"
    type="success"
    text="Rename"
    (onClick)="rename()"
  >
  </dx-button>
  <dx-button
    icon="close"
    text="Cancel"
    (onClick)="activeModal.dismiss('Cross click')"
  >
  </dx-button>
</div>